import { LapFinancialType } from '@modules/types/graphql';

const financialTypeTranslates = {
    [LapFinancialType.budget]: 'common:blocks.lap_financial_type.budget',
    [LapFinancialType.commercial]: 'common:blocks.lap_financial_type.commercial',
};

const financialTypesOptions = Object.entries(LapFinancialType).map(([_, value]) => ({
    key: value,
    value: financialTypeTranslates[value] ?? value,
}));

export { financialTypeTranslates, financialTypesOptions };
